export default __webpack_public_path__ + "static/media/alchemy-badge-light.80d87d24.svg";